import { useEffect, useState } from "react";
import PageTitle from "../../../../components/PageTitle";
import api from "../../../../services/api";
import Spinner from "../../../../shared/Spinner/Spinner";
import { Installment, PaymentOption } from "../EnterprisePaymentOptions";
import Style from "./InstallmentPageStyle"

export default function InstallmentPage(props) {

  const [loading, setLoading] = useState(true);

  const [installment, setInstallment] = useState(1);
  const [paymentOptionId, setPaymentOptionId] = useState(0);
  const [paymentOption, setPaymentOption] = useState("");
  const [maxDate, setMaxDate] = useState("");
  const [interestRate, setInterestRate] = useState(0);

  const installmentId = parseInt(props.match.params.installmentId || "0");


  useEffect(() => {
    if (installmentId > 0) {
      LoadInstallment()
    }
    else {
      LoadPaymentOption()
    }
  }, [])

  async function LoadInstallment() {
    try {
      const result = await api.get(`/enterprises/${props.match.params.enterpriseId}/installment`);
      const data: Installment = result.data.installments.find(obj => {
        return obj.id === parseInt(props.match.params.installmentId);
      });
      setInstallment(data.installment);
      setPaymentOptionId(data.paymentOptionId);
      setPaymentOption(data.paymentOptions.name);
      setMaxDate(new Date(data.maxDate).toISOString().split('T')[0]);
      setInterestRate(data.interestRate);
    }
    catch (error) {
      console.log(error);
    }
    finally {
      setLoading(false);
    }
  }

  async function LoadPaymentOption() {
    try {
      const result = await api.get(`/enterprises/${props.match.params.enterpriseId}/paymentOption`)
      const data: PaymentOption = result.data.paymentOptions.find(obj => {
        return obj.id === parseInt(props.match.params.paymentOptionId);
      });
      setPaymentOptionId(data.id);
      setPaymentOption(data.name)
    }
    catch (error) {
      console.log(error)
    }
    finally {
      setLoading(false);
    }
  }

  async function AddInstallment() {
    setLoading(true);
    try {
      const adjustedDate = maxDate + "T00:00:00.000Z"
      const data: any = { installment, paymentOptionId, maxDate: adjustedDate, interestRate };
      if (installmentId) {
        data.id = installmentId;
        console.log("Vai atualizar pagamento");
        await api.put(`/enterprises/${props.match.params.enterpriseId}/installment`, data);
      }
      else {
        console.log("Vai criar pagamento");
        await api.post(`/enterprises/${props.match.params.enterpriseId}/installment`, data);
      }

      props.history.goBack();
    }
    catch (error) {
      console.log(error)
    }
    finally {
      setLoading(false)
    }
  }

  return (
    <Style className="default-page">
      <PageTitle title={props.match.params.installmentId > 0 ? "Editar parcela" : "Adicionar parcela"} />
      <div>
        <button onClick={() => props.history.goBack()} className=" btn-secondary go-back">Voltar</button>
      </div>
      <Spinner spinning={loading} />
      <main className="default-main">
        <div className="panel">
          <form className="main-form" onSubmit={(e) => { e.preventDefault(); }}>
            <h2>{props.match.params.installmentId > 0 ? "Edição" : "Criação"} de parcela</h2>
            <div>
              <label>Opção de pagamento:</label>
              <span><b>{paymentOption}</b></span>
            </div>
            <div>
              <label>Parcelas:</label>
              <input
                type="number"
                disabled={loading}
                value={installment}
                min="1"
                max="32"
                onChange={e => setInstallment(parseInt(e.target.value))}
              />
            </div>
            <div>
              <label>Data límite:</label>
              <input
                type="date"
                value={maxDate}
                disabled={loading}
                onChange={e => setMaxDate(e.target.value)}
              />
            </div>
            <div>
              <label>Taxa de juros:</label>
              <input
                type="number"
                disabled={loading}
                value={interestRate}
                min="-100"
                max="100"
                onChange={e => setInterestRate(parseFloat(e.target.value))}
              />
            </div>
            <button
              className="btn btn-success btn-lg mt-4"
              type="button"
              disabled={loading || !installment || paymentOptionId === undefined || !maxDate}
              onClick={e => {
                e.preventDefault();
                AddInstallment()
              }
              }>{props.match.params.installmentId > 0 ? "Alterar" : "Adicionar"}</button>
          </form>
        </div>
      </main>
    </Style>
  )
}
